export abstract class DocumentUtils {

    /**
     * 
     * @param blob The binary blob of the document
     * @param documentName If not opening in a new tab, the name of the file to save as
     * @param openInNewTab Whether to open the file in a new tab or not
     */
    public static openDoc(blob: Blob, documentName: string, openInNewTab: boolean, fileExtension?: string) {

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
            return;
        }

        // For other browsers: 
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(blob);

        if (openInNewTab) {
            window.open(data);
        }
        else {
            const link = document.createElement('a');
            link.href = data;

            if (fileExtension) {
                link.download = `${documentName}.${fileExtension}`;
            }
            else {
                link.download = `${documentName}.pdf`;
            }

            if (this.isFirefox()) {
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
            else {
                link.click();
            }
        }

        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    }

    private static isFirefox = () => {
        return window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }
}